var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5H6.5A1.5 1.5 0 0 1 5 2V1zm3.5.207L7.293 2.5H6.5A.5.5 0 0 1 6 2zM1 1.5A1.5 1.5 0 0 1 2.5 0h3.086a1.5 1.5 0 0 1 1.06.44l1.915 1.914A1.5 1.5 0 0 1 9 3.414V8.5A1.5 1.5 0 0 1 7.5 10h-5A1.5 1.5 0 0 1 1 8.5zm10 4a.5.5 0 0 0-1 0v4A1.5 1.5 0 0 1 8.5 11H5a.5.5 0 0 0 0 1h3.5A2.5 2.5 0 0 0 11 9.5z",
    clipRule: "evenodd"
  })));
});
const SvgFilessmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilessmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjUgMUMyLjIyMzg2IDEgMiAxLjIyMzg2IDIgMS41VjguNUMyIDguNzc2MTQgMi4yMjM4NiA5IDIuNSA5SDcuNUM3Ljc3NjE0IDkgOCA4Ljc3NjE0IDggOC41VjMuNTAwMTVINi41QzUuNjcxNTcgMy41MDAxNSA1IDIuODI4NTggNSAyLjAwMDE1VjFIMi41Wk02IDEuMjA3MTFMNy4yOTMwNCAyLjUwMDE1SDYuNUM2LjIyMzg2IDIuNTAwMTUgNiAyLjI3NjI5IDYgMi4wMDAxNVYxLjIwNzExWk0xIDEuNUMxIDAuNjcxNTczIDEuNjcxNTcgMCAyLjUgMEg1LjU4NTc5QzUuOTgzNjEgMCA2LjM2NTE0IDAuMTU4MDM1IDYuNjQ2NDUgMC40MzkzNEw4LjU2MDY2IDIuMzUzNTVDOC44NDE5NiAyLjYzNDg2IDkgMy4wMTYzOSA5IDMuNDE0MjFWOC41QzkgOS4zMjg0MyA4LjMyODQzIDEwIDcuNSAxMEgyLjVDMS42NzE1NyAxMCAxIDkuMzI4NDMgMSA4LjVWMS41Wk0xMSA1LjVDMTEgNS4yMjM4NiAxMC43NzYxIDUgMTAuNSA1QzEwLjIyMzkgNSAxMCA1LjIyMzg2IDEwIDUuNVY5LjVDMTAgMTAuMzI4NCA5LjMyODQzIDExIDguNSAxMUg1QzQuNzIzODYgMTEgNC41IDExLjIyMzkgNC41IDExLjVDNC41IDExLjc3NjEgNC43MjM4NiAxMiA1IDEySDguNUM5Ljg4MDcxIDEyIDExIDEwLjg4MDcgMTEgOS41VjUuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";